// extracted by mini-css-extract-plugin
module.exports = {"md":"news_md_34U8N","ios":"news_ios_2ZmSk","page":"news_page_3e5-O","empty":"news_empty_paNVq","preloader":"news_preloader_3eAkL"};